
        $(document).ready(function(){
          $(document).on('click', '.read-more', function(){
            $('.collection_description').removeClass('fixed--content');
          })
          $(document).on('click', '.read-less', function(){
            $('.collection_description').addClass('fixed--content');
          })
        })